import React from 'react';

const THead = ({ onSortChange }) => {
    return (
        <thead>
            <tr>
                <th onClick={() => onSortChange('affid')}>Affid</th>
                <th onClick={() => onSortChange('country')}>Country</th>
                <th onClick={() => onSortChange('subid')}>Device</th>
                <th onClick={() => onSortChange('spends')}>Spends</th>
                <th onClick={() => onSortChange('conversions')}>Conversions</th>
                <th onClick={() => onSortChange('eCost')}>eCost</th>
            </tr>
        </thead>
    );
};

export default THead;



// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/PeriodCountryTable/components/THead/index.js